import { authRoutes } from "./auth.js";
import { optionsRoutes } from "./options.js";
import { webRoutes } from "./web.js";
import { vendorRoutes } from "./vendor.js";

export const routes = [...webRoutes, ...optionsRoutes, ...authRoutes, ...vendorRoutes];

export const getFilteredRoutes = () => {
	return routes.filter((route) => route.enabled === true);
};
